import { IAutocompleteResults } from '../state-helpers/autocomplete';
import * as actions from '../actions/autocomplete-actions';
import * as _ from 'lodash';

const defaultAutocompleteResultsModel = Object.freeze({
    //Using -1 to indicate none selected
    hits: [],
    activeHit: -1,
    isActive: false
});


export function autocompleteModel(state: IAutocompleteResults, action: actions.IAutocompleteAction) {
    if (typeof state === 'undefined') {
        return defaultAutocompleteResultsModel
    }

    switch (action.type) {
        case actions.AutocompleteActionType.SET_AUTOCOMPLETE_HITS:
            return _.assign({}, state, { hits: action.hits });
        case actions.AutocompleteActionType.SET_AUTOCOMPLETE_ACTIVE:
            return _.assign({}, state, { isActive: action.isActive });
        case actions.AutocompleteActionType.SET_AUTOCOMPLETE_ACTIVE_HIT:
            return _.assign({}, state, { activeHit: action.activeHit });
        default:
            return state;
    }
}